import { IGif, IUser } from "services/types";

export interface IHomeState {
  homeGifs: IFeedData;
  loading: boolean;
  errorMessage?: string;
}

interface IFeedData {
  horizontalGifs: IGif[];
  hotCreators: IUser[];
  hotGifs: IGif[];
  hotImages: IGif[];
  longGifs: IGif[];
  newCreators: IUser[];
  soundGifs: IGif[];
  verifiedGifs: IGif[];
  verifiedImages: IGif[];
  verticalGifs: IGif[];
}

const defaultState = {
  homeGifs: {
    horizontalGifs: [],
    hotCreators: [],
    hotGifs: [],
    hotImages: [],
    longGifs: [],
    newCreators: [],
    soundGifs: [],
    verifiedGifs: [],
    verifiedImages: [],
    verticalGifs: [],
  },
  loading: false
};

export const getDefaultHomeState = () => defaultState;
